export const LANGCHAIN_DEFAULT_NAMES = new Set([
  // exported from @langchain/core/load by iterating
  // on every export and invoking lc_name() where applicable
  'Agent',
  'AgentActionOutputParser',
  'AgentExecutor',
  'BaseMultiActionAgent',
  'BaseSingleActionAgent',
  'ChatAgent',
  'ChatAgentOutputParser',
  'ChatConversationalAgent',
  'ChatConversationalAgentOutputParser',
  'ChatConversationalAgentOutputParserWithRetries',
  'LLMSingleActionAgent',
  'OpenAIAgent',
  'RunnableAgent',
  'StructuredChatAgent',
  'StructuredChatOutputParser',
  'StructuredChatOutputParserWithRetries',
  'XMLAgent',
  'ZeroShotAgent',
  'ZeroShotAgentOutputParser',
  'OpenAIFunctionsAgentOutputParser',
  'OpenAIToolsAgentOutputParser',
  'ReActSingleInputOutputParser',
  'XMLAgentOutputParser',
  'APIChain',
  'AnalyzeDocumentChain',
  'BaseChain',
  'ChatVectorDBQAChain',
  'ConstitutionalChain',
  'ConversationChain',
  'ConversationalRetrievalQAChain',
  'LLMChain',
  'LLMRouterChain',
  'MapReduceDocumentsChain',
  'MultiRouteChain',
  'OpenAIModerationChain',
  'RefineDocumentsChain',
  'RetrievalQAChain',
  'RouterChain',
  'SequentialChain',
  'SimpleSequentialChain',
  'StuffDocumentsChain',
  'TransformChain',
  'VectorDBQAChain',
  'ChatAnthropic',
  'ChatFireworks',
  'ChatOpenAI',
  'MetadataTagger',
  'FakeChatMessageHistory',
  'FakeChatModel',
  'FakeLLM',
  'FakeListChatMessageHistory',
  'FakeListChatModel',
  'FakeRetriever',
  'FakeRunnable',
  'FakeSplitIntoListParser',
  'FakeStreamingChatModel',
  'FakeStreamingLLM',
  'FakeTool',
  'FakeTracer',
  'SingleRunExtractor',
  'CriteriaEvalChain',
  'CriteriaResultOutputParser',
  'EmbeddingDistanceEvalChain',
  'LabeledPairwiseStringEvalChain',
  'PairwiseEmbeddingDistanceEvalChain',
  'PairwiseStringEvalChain',
  'PairwiseStringResultOutputParser',
  'QAEvalChain',
  'TrajectoryEvalChain',
  'TrajectoryOutputParser',
  'AutoGPTOutputParser',
  'AutoGPTPrompt',
  'BabyAGI',
  'TaskCreationChain',
  'TaskExecutionChain',
  'TaskPrioritizationChain',
  'ViolationOfExpectationsChain',
  'NIBittensorLLM',
  'GenerativeAgent',
  'OpenAIAssistantRunnable',
  'OpenAIFiles',
  'PlanAndExecuteAgentExecutor',
  'PlanOutputParser',
  'CustomPromptTemplate',
  'FakeListLLM',
  'Fireworks',
  'OpenAI',
  'AsymmetricStructuredOutputParser',
  'CombiningOutputParser',
  'CommaSeparatedListOutputParser',
  'CustomListOutputParser',
  'DatetimeOutputParser',
  'HttpResponseOutputParser',
  'JsonKeyOutputFunctionsParser',
  'JsonMarkdownStructuredOutputParser',
  'JsonOutputFunctionsParser',
  'JsonOutputKeyToolsParser',
  'JsonOutputToolsParser',
  'ListOutputParser',
  'OutputFixingParser',
  'OutputFunctionsParser',
  'RegexParser',
  'StructuredOutputParser',
  'StringPromptValue',
  'AIMessagePromptTemplate',
  'ChatMessagePromptTemplate',
  'ChatPromptTemplate',
  'HumanMessagePromptTemplate',
  'MessagesPlaceholder',
  'SystemMessagePromptTemplate',
  'ImagePromptTemplate',
  'PipelinePromptTemplate',
  'PromptTemplate',
  'ContextualCompressionRetriever',
  'HydeRetriever',
  'VectorStoreRetriever',
  'MultiQueryRetriever',
  'MultiVectorRetriever',
  'ParentDocumentRetriever',
  'ChatGPTPluginRetriever',
  'RemoteLangChainRetriever',
  'RemoteRetriever',
  'TimeWeightedVectorStoreRetriever',
  'VespaRetriever',
  'RemoteRunnable',
  'AIMessage',
  'AIMessageChunk',
  'BaseMessage',
  'BaseMessageChunk',
  'ChatMessage',
  'ChatMessageChunk',
  'FunctionMessage',
  'FunctionMessageChunk',
  'HumanMessage',
  'HumanMessageChunk',
  'SystemMessage',
  'SystemMessageChunk',
  'ToolMessage',
  'ToolMessageChunk',
  'StrOutputParser',
  'RouterRunnable',
  'RunnableAssign',
  'RunnableBinding',
  'RunnableBranch',
  'RunnableEach',
  'RunnableMap',
  'RunnablePassthrough',
  'RunnablePick',
  'RunnableRetry',
  'RunnableSequence',
  'RunnableWithFallbacks',
  'EncoderBackedStore',
  'InMemoryStore',
  'InMemoryFileStore',
  'ChatMessageHistory',
  'CharacterTextSplitter',
  'RecursiveCharacterTextSplitter',
  'TextSplitter',
  'TokenTextSplitter',
  'ChainTool',
  'MemoryVectorStore',

  // exported from Python Langchain by adding every ID found
  // in langchain_core.load.load.ALL_SERIALIZABLE_MAPPINGS
  'AgentAction',
  'AgentActionMessageLog',
  'AgentFinish',
  'AIMessage',
  'AIMessageChunk',
  'AIMessagePromptTemplate',
  'AzureChatOpenAI',
  'AzureOpenAI',
  'BaseChatPromptTemplate',
  'BaseMessage',
  'BaseMessageChunk',
  'BaseMessagePromptTemplate',
  'BaseOpenAI',
  'BasePromptTemplate',
  'BaseStringMessagePromptTemplate',
  'Bedrock',
  'BedrockChat',
  'ChatAnthropic',
  'ChatFireworks',
  'ChatGeneration',
  'ChatGenerationChunk',
  'ChatMessage',
  'ChatMessageChunk',
  'ChatMessagePromptTemplate',
  'ChatOpenAI',
  'ChatPromptTemplate',
  'ChatPromptValue',
  'ChatPromptValueConcrete',
  'ChatVertexAI',
  'CombiningOutputParser',
  'CommaSeparatedListOutputParser',
  'Document',
  'DynamicRunnable',
  'FewShotPromptWithTemplates',
  'Fireworks',
  'FunctionMessage',
  'FunctionMessageChunk',
  'Generation',
  'GenerationChunk',
  'HubRunnable',
  'HumanMessage',
  'HumanMessageChunk',
  'HumanMessagePromptTemplate',
  'ImagePromptTemplate',
  'LLMChain',
  'MessagesPlaceholder',
  'OpenAI',
  'OpenAIFunctionsRouter',
  'OpenAIToolAgentAction',
  'OutputFixingParser',
  'PipelinePromptTemplate',
  'PromptTemplate',
  'PromptValue',
  'RegexParser',
  'Replicate',
  'RouterRunnable',
  'RunnableAssign',
  'RunnableBinding',
  'RunnableBindingBase',
  'RunnableBranch',
  'RunnableConfigurableAlternatives',
  'RunnableConfigurableFields',
  'RunnableEach',
  'RunnableEachBase',
  'RunnableParallel',
  'RunnablePassthrough',
  'RunnableRetry',
  'RunnableSequence',
  'RunnableWithFallbacks',
  'RunnableWithMessageHistory',
  'StringPromptTemplate',
  'StringPromptValue',
  'StrOutputParser',
  'StructuredPrompt',
  'SystemMessage',
  'SystemMessageChunk',
  'SystemMessagePromptTemplate',
  'ToolAgentAction',
  'ToolMessage',
  'ToolMessageChunk',
  'VertexAI',

  // LangGraph nodes
  'ChannelWrite',
  'ChannelRead',
  'ChannelInvoke',
  'ChannelBatch',
  'LangGraph',
  'Pregel',

  // https://langchain.slack.com/archives/C04GMBZ9Y1Y/p1713917603351909
  'ToolsAgentOutputParser',
]);
